module.exports = "https://files.cnvos.si/static/images/drugo.png?e960f6b8f8abdd8cd7bdeb0af119cb59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/drugo.png
// module id = 128
// module chunks = 1 2